import { GetServerSideProps } from 'next';

import createApolloClient from 'src/modules/ApolloWrapper/createApolloClient';
import {
  GetDistrictsWithActiveJobsData,
  queryDistrictsWithActiveJobs,
} from 'src/modules/Seo/graphql';
import JobsByNewLocation from 'src/modules/Seo/JobsByNewLocation';

export default JobsByNewLocation;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req, res, resolvedUrl } = context;

  res.setHeader(
    'Cache-Control',
    'public, s-maxage=3600, stale-while-revalidate=3599'
  );

  const isPaginationURL = resolvedUrl?.includes('?page=');

  if (isPaginationURL) {
    return {
      redirect: {
        destination: resolvedUrl.replace(/\?page=\d+/, ''),
        permanent: true,
      },
    };
  }

  const { dstContext } = req;
  const { clientConfig } = dstContext;
  const { COUNTRY: country } = clientConfig;

  const apolloClient = createApolloClient({
    listenPort: dstContext.listenPort,
    token: dstContext.accessToken,
    cookie: req.headers.cookie,
    ssrToken: dstContext.ssrToken,
    remoteAddress: dstContext.remoteAddress,
    xForwardedFor: req.headers['x-forwarded-for'],
    locale: clientConfig?.LANG,
    country: clientConfig?.COUNTRY,
  });

  let initialDistrictsData = null;
  try {
    const { data: districtsWithActiveJobsData } =
      await apolloClient.query<GetDistrictsWithActiveJobsData>({
        query: queryDistrictsWithActiveJobs,
        variables: {
          countryCode: country,
          shouldGetAllData: true,
        },
      });
    initialDistrictsData = districtsWithActiveJobsData;
  } catch (error) {
    console.error('Error fetching districts', error);
  }

  return {
    props: {
      initialDistrictsData,
    },
  };
};
